var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m141.86,326.47h152.63c4.59,0,8.32-3.72,8.32-8.32s-3.72-8.32-8.32-8.32h-152.63c-4.6,0-8.32,3.72-8.32,8.32s3.72,8.32,8.32,8.32",
    fill: "#f7f7f7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m141.86,259.92h152.63c4.59,0,8.32-3.72,8.32-8.32s-3.72-8.32-8.32-8.32h-152.63c-4.6,0-8.32,3.72-8.32,8.32s3.72,8.32,8.32,8.32",
    fill: "#f7f7f7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m141.86,193.38h152.63c4.59,0,8.32-3.72,8.32-8.32s-3.72-8.32-8.32-8.32h-152.63c-4.6,0-8.32,3.72-8.32,8.32s3.72,8.32,8.32,8.32",
    fill: "#f7f7f7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m346.57,114.17l-38.12-38.12-38.12-38.12c-1.55-1.55-3.69-2.44-5.88-2.44H89.32c-2.19,0-4.33.89-5.88,2.44-1.55,1.55-2.44,3.69-2.44,5.88v342.36c0,2.19.89,4.33,2.44,5.88,1.55,1.55,3.69,2.44,5.88,2.44h251.37c2.19,0,4.33-.89,5.88-2.44,1.55-1.55,2.44-3.69,2.44-5.88V120.06c0-2.19-.89-4.33-2.44-5.88Zm-73.29-49.77l23.41,23.41,21.18,21.18h-44.59v-44.59ZM97.63,377.86V52.14h159c0,39.08,0,65.18,0,65.18,0,2.19.89,4.33,2.44,5.88,1.55,1.55,3.69,2.44,5.88,2.44h62.12c2.01,0,3.86-.71,5.29-1.9v254.13s-164.7,0-164.7,0h-70.03Z",
    fill: "#f7f7f7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.6107c19c9785d1515b8535b0fe511197.svg";
export { ForwardRef as ReactComponent };